export default "__VITE_ASSET__DUJ60ye6__";